import { Component, OnInit, Input, Inject, EventEmitter, Output, Renderer2 } from '@angular/core';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material';

import {
  IcecontrolSettings,
  IcemattableSettings,
  IcepanelgroupSettings,
  IcepanelsectionSettings,
  IcepanelSettings,
  IcepanelcontainerRowSettings,
  IcepanelcontainerSettings,
  IceexpansionpanelSettings,

  iceColumnDefinition,
  SECTION_CONTROL_ALIGNMENT
} from '../../../../icemedx-lib/src/components/models/icesettings';

import { Iceutility } from '../../services/iceutility';
import { IceTypes } from '../../models/icetypes';

@Component({
  selector: 'icebottomsheet',
  templateUrl: './icebottomsheet.component.html',
  styleUrls: ['./icebottomsheet.component.scss']
})
export class IcebottomSheetComponent implements OnInit {
  bottomsheetSettings: IcepanelcontainerSettings = null;
  panelsInSheet: IcepanelSettings[] = [];

  constructor(private bottomSheetRef: MatBottomSheetRef<IcebottomSheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any) {
    this.panelsInSheet = data == null || data["panels"] == null ? [] : <IcepanelSettings[]>data["panels"];
    this.bottomsheetSettings = this.viewSetup();
  }

  viewSetup(): IcepanelcontainerSettings {
    let setup: IcepanelcontainerSettings = null;
    try {

      let panelrows: IcepanelcontainerRowSettings[] = [
        new IcepanelcontainerRowSettings(this.panelsInSheet)
      ];
      setup = new IcepanelcontainerSettings("ButtomSheetContainer", panelrows).setStep(-1);
    }
    catch (e) {
      console.log(e);
    }
    return setup;
  }

  ngOnInit() {
  }
  openLink(event: MouseEvent): void {
    this.bottomSheetRef.dismiss();
    event.preventDefault();
  }
}
